// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hierarchy-tree {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.hierarchy-tree-node {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.hierarchy-tree-children {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  padding-left: 1.35rem;
  border-left: 0.125rem solid var(--gray);
  margin-left: 0.55rem;
}

.hierarchy-tree-card {
  border-radius: 0.6rem;
  box-shadow: 0 0 0.75rem rgba(0, 0, 0, 0.08);
}

.hierarchy-tree-card.is-search-match {
  z-index: 2;
  border-color: #0a8c66 !important;
  border-width: 0.25rem !important;
  border-style: solid !important;
  outline: 0.1875rem solid rgba(10, 140, 102, 0.28);
  outline-offset: 0.125rem;
  box-shadow:
    0 0 0 0.35rem rgba(10, 140, 102, 0.26),
    0 0 1.9rem rgba(10, 140, 102, 0.46);
  background: linear-gradient(180deg, #ffffff 0%, #d8f6ea 100%);
  transform: translateY(-0.0625rem);
}

.hierarchy-tree-card.is-search-match .hierarchy-tree-name {
  color: var(--primary-color);
}

.hierarchy-tree-card.is-search-match .card-header,
.hierarchy-tree-card.is-search-match .card-body {
  background-color: transparent;
}

.hierarchy-tree-card.is-search-match .badge {
  box-shadow: 0 0.1rem 0.35rem rgba(0, 127, 92, 0.14);
}

.hierarchy-tree-card-header {
  background: var(--white);
}

.hierarchy-tree-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.hierarchy-tree-header-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.hierarchy-tree-header-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
}

.hierarchy-tree-header-title {
  display: flex;
  align-items: center;
  min-width: 0;
}

.hierarchy-tree-title-content {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}

.hierarchy-tree-name {
  font-weight: 700;
  color: var(--secondary-color);
  line-height: 1.2;
}

.hierarchy-tree-toggle,
.hierarchy-tree-details {
  border: 0;
  background: transparent;
  color: var(--secondary-color);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.25rem 0.4rem;
  line-height: 1;
}

.hierarchy-tree-header-actions .badge,
.hierarchy-tree-details {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.hierarchy-tree-header-actions .badge {
  min-height: 2rem;
  text-align: center;
}

.hierarchy-tree-toggle:hover,
.hierarchy-tree-details:hover {
  color: var(--primary-color);
}

.hierarchy-tree-toggle {
  font-size: 1rem;
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
}

.hierarchy-tree-details {
  font-weight: 600;
  min-height: 2rem;
}

.hierarchy-tree-details svg {
  width: 0.95rem;
  height: 0.95rem;
}

.hierarchy-tree-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.5rem;
  margin-top: 0.45rem;
  color: var(--secondary-color);
}

.hierarchy-tree-meta strong {
  color: var(--secondary-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/HierarchyTreeView/HierarchyTreeView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,gCAAgC;EAChC,8BAA8B;EAC9B,iDAAiD;EACjD,wBAAwB;EACxB;;uCAEqC;EACrC,6DAA6D;EAC7D,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".hierarchy-tree {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.hierarchy-tree-node {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.9rem;\r\n}\r\n\r\n.hierarchy-tree-children {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.9rem;\r\n  padding-left: 1.35rem;\r\n  border-left: 0.125rem solid var(--gray);\r\n  margin-left: 0.55rem;\r\n}\r\n\r\n.hierarchy-tree-card {\r\n  border-radius: 0.6rem;\r\n  box-shadow: 0 0 0.75rem rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.hierarchy-tree-card.is-search-match {\r\n  z-index: 2;\r\n  border-color: #0a8c66 !important;\r\n  border-width: 0.25rem !important;\r\n  border-style: solid !important;\r\n  outline: 0.1875rem solid rgba(10, 140, 102, 0.28);\r\n  outline-offset: 0.125rem;\r\n  box-shadow:\r\n    0 0 0 0.35rem rgba(10, 140, 102, 0.26),\r\n    0 0 1.9rem rgba(10, 140, 102, 0.46);\r\n  background: linear-gradient(180deg, #ffffff 0%, #d8f6ea 100%);\r\n  transform: translateY(-0.0625rem);\r\n}\r\n\r\n.hierarchy-tree-card.is-search-match .hierarchy-tree-name {\r\n  color: var(--primary-color);\r\n}\r\n\r\n.hierarchy-tree-card.is-search-match .card-header,\r\n.hierarchy-tree-card.is-search-match .card-body {\r\n  background-color: transparent;\r\n}\r\n\r\n.hierarchy-tree-card.is-search-match .badge {\r\n  box-shadow: 0 0.1rem 0.35rem rgba(0, 127, 92, 0.14);\r\n}\r\n\r\n.hierarchy-tree-card-header {\r\n  background: var(--white);\r\n}\r\n\r\n.hierarchy-tree-header-content {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.hierarchy-tree-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  min-width: 0;\r\n}\r\n\r\n.hierarchy-tree-header-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem;\r\n  justify-content: center;\r\n}\r\n\r\n.hierarchy-tree-header-title {\r\n  display: flex;\r\n  align-items: center;\r\n  min-width: 0;\r\n}\r\n\r\n.hierarchy-tree-title-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.2rem;\r\n  min-width: 0;\r\n}\r\n\r\n.hierarchy-tree-name {\r\n  font-weight: 700;\r\n  color: var(--secondary-color);\r\n  line-height: 1.2;\r\n}\r\n\r\n.hierarchy-tree-toggle,\r\n.hierarchy-tree-details {\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--secondary-color);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.4rem;\r\n  padding: 0.25rem 0.4rem;\r\n  line-height: 1;\r\n}\r\n\r\n.hierarchy-tree-header-actions .badge,\r\n.hierarchy-tree-details {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.hierarchy-tree-header-actions .badge {\r\n  min-height: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.hierarchy-tree-toggle:hover,\r\n.hierarchy-tree-details:hover {\r\n  color: var(--primary-color);\r\n}\r\n\r\n.hierarchy-tree-toggle {\r\n  font-size: 1rem;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  flex: 0 0 2rem;\r\n}\r\n\r\n.hierarchy-tree-details {\r\n  font-weight: 600;\r\n  min-height: 2rem;\r\n}\r\n\r\n.hierarchy-tree-details svg {\r\n  width: 0.95rem;\r\n  height: 0.95rem;\r\n}\r\n\r\n.hierarchy-tree-meta {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem 1.5rem;\r\n  margin-top: 0.45rem;\r\n  color: var(--secondary-color);\r\n}\r\n\r\n.hierarchy-tree-meta strong {\r\n  color: var(--secondary-color);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
